import { Injectable } from '@angular/core';
import { HttpService } from '../../services/http/http.service';
import { Path } from '../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpService
  ) { }

  getUserDetails(params) {
    // console.log(params);
    return this.http.get(Path.LOGIN.GET_USER_DETAILS, params);
  }

  updateLastChangePasswordDate(data: any) {
    return this.http.post(Path.LOGIN.UPDATE_LAST_CHANGE_PASSWORD_DATE, data);
  }
}
